export const Work = [
  {
    name: "Reelify AI - Reel Generator built using python and flask",
    description:
      "Dive into the future of content creation with the Reelify AI Project! 🚀 Powered by Python and Flask, this innovative AI tool supercharges creativity like never before. Watch now to explore its powerful features, real-world uses,It is a SASS Product",
    tags: ["Python", "flask", "eleven labs", "ffmpeg"],

    demo: "https://youtu.be/bCBSEQnhkgg?si=hQInsFmbjYcZ8dNv",
    github: "https://github.com/pratikk5/Reelify-AI",
  },
  {
    name: "Get me a chai",
    description:
      "Get Me a Chai is a crowdfunding platform designed for creators to fund their projects with the support of their fans. It's a space where your fans can directly contribute to your creative endeavors by buying you a chai. Unlock the potential of your fanbase and bring your projects to life.",
    tags: ["nextjs", "nextauth", "razorpay", "mongodb"],

    demo: "https://get-me-a-chai-pratik.netlify.app/",
    github: "https://github.com/pratikk5/get-me-a-chai",
  },
  {
    name: "Pathology lab website",
    description:
      "This is a professional and fully responsive Lab Website designed to present the work, services, and vision of a medical diagnostic laboratory. The website features dedicated sections including Home, About, Services, Book Appointment, Reviews, Gallery, and Contact, offering a seamless user experience.",
    tags: ["Vite", "Typescript", "React", "shadcn-ui", "Tailwind CSS"],

    demo: "https://shubhangi-lab.lovable.app/",
    github: "https://github.com/pratikk5/shubhangi-lab-ui-revive",
  },
  {
    name: "CopBotChatbox",
    description:
      "CopBotChatbox is an AI-driven chatbot that provides users with instant assistance on legal rights, police interactions, and emergency services. Built using Next.js and Firebase, it ensures fast, secure communication while emphasizing user privacy and cybersecurity.",
    tags: ["Next.js", "AI", "firebase", "cybersecurity"],

    demo: "https://copbotchatbox.web.app/",
    github: "https://github.com/pratikk5/copbotchatbox",
  },
  // {
  //   name: "Gen AI Projects",
  //   description:
  //     "Your all-in-one AI-powered companion for learning Data Structures & Algorithms 📚, exploring startup opportunities in India 🚀, and more future-ready projects. Instant solutions, smart guidance, and real-time support—all in one place.",
  //   tags: ["GenAI", "api", "keys", "serverless", "html"],

  //   demo: "https://gen-ai-projects-by-pratik.netlify.app/",
  //   github: "https://github.com/pratikk5/gen-ai-projects",
  // },
  {
    name: "Full-Stack Instagram Clone",
    description:
      "Developed a full-stack Instagram clone using React, Firebase, and Zustand, replicating core social media functionalities.Implemented user authentication, profile management, real-time posting, commenting, and like features with responsive UI.Configured Firebase Firestore, Storage, and Security Rules for scalable backend and deployed the application securely.",
    tags: ["React", "Firebase", "Chakra UI", "Zustand", "JavaScript"],

    demo: "https://fullstack-insta-clone-by-pratik.netlify.app/",
    github: "https://github.com/pratikk5/Instagram-clone",
  },
  {
    name: "Python Projects: Scraping, Cleaning & ML",
    description:
      "This collection highlights real-world data science projects using Python. It covers web scraping, data visualization, and cleaning with Pandas, plus sentiment analysis on IMDb reviews using machine learning. Each project demonstrates key skills in data handling and analysis.",
    tags: ["Python", "Pandas", "Matplotlib", "Scikit-learn"],

    demo: "https://python-datascience-projects.netlify.app/",
    github: "https://github.com/pratikk5/python-for-datascience",
  },
  {
    name: "Python Project Collection – Utility, Games & Productivity Apps",
    description:
      "Python Project Pack:A collection of 5 beginner-friendly Python apps including a calculator, quiz game, PDF merger, news reader, and water reminder.Each project focuses on practical functionality and core Python concepts.",
    tags: ["Python", "api", "File Handling", "PyPDF2"],

    demo: "https://python-projects.netlify.app/",
    github: "https://github.com/pratikk5/python-projects",
  },

  {
    name: "Subscription Tracker Backend API",
    description:
      "Secure app-wide with Arcjet bot protection, structured MongoDB models with Mongoose, user CRUD and subscriptions, smart email automation via Upstash, and a clean, reusable codebase.",
    tags: ["nodejs", "express", "mongodb", "nodemailer"],

    demo: "https://youtu.be/OpAkJZ1j3WQ?feature=shared",
    github: "https://github.com/pratikk5/subscription-tracker-backend",
  },
  {
    name: "Snap URL",
    description:
      "Snap URL is a simple and secure URL shortener that lets users shorten long links without tracking or login requirements. It provides a fast, user-friendly experience with a clean and responsive design. Built with Next.js, it ensures seamless performance across all devices.",
    tags: ["nextjs", "localstorage", "tailwindcss", "vercel"],

    demo: "https://snap-url-sand.vercel.app/",
    github: "https://github.com/pratikk5/snap-url",
  },

  {
    name: "Spotify Clone",
    description:
      "This feature-rich music streaming application allows users to play, pause, and skip songs, offering seamless control over playback. An intuitive volume control slider provides a personalized listening experience. The platform includes a robust admin dashboard where administrators can easily manage albums and songs, including uploading, editing, and deleting music content.",
    tags: ["react", "vite", "clerk", "socket.io"],

    demo: "https://spotify-clone-by-pratik.netlify.app/",
    github: "https://github.com/pratikk5/spotify-clone-by-pratik",
  },
  {
    name: "Hash Valut",
    description:
      "This project is a personal password manager built using React with Vite, offering a lightweight, fast, and responsive web interface. It allows users to securely store, view, and manage their passwords directly within the browser. All password data is stored locally in the browser's local storage, ensuring that sensitive information remains on the user's device and never leaves it — no external servers or databases are involved.",
    tags: ["react", "vite", "toastify react"],

    demo: "https://hashvalut.web.app/",
    github: "https://github.com/pratikk5/HashValut",
  },
  {
    name: "Focus Tasks",
    description:
      "This is a simple yet effective Todo List application built on top of React.js, designed to help users efficiently manage their tasks in one place. With a clean and intuitive interface, users can add, edit, mark as complete, and delete todos effortlessly.The application emphasizes productivity and ease of use, making it ideal for daily planning, reminders, or project task management.",
    tags: ["react", "form handling", "list"],

    demo: "https://focus-tasks-react-app-by-pratik.netlify.app/",
    github: "https://github.com/pratikk5/Focus-Tasks",
  },

  {
    name: "Netflix frontend Clone",
    description:
      "This is a simple yet elegant Video Streaming Platform built entirely using HTML and CSS, showcasing the power of front-end technologies to create engaging user experiences. The platform features dynamic content loading through clean structuring and modular design, allowing viewers to explore multiple videos seamlessly. With a responsive and scalable layout, the site adapts beautifully across devices of all screen sizes.",
    tags: ["HTML", "CSS"],

    demo: "https://netflix-project-by-pratik-60031549592.development.catalystserverless.in/app/index.html",
    github: "https://github.com/pratikk5/netflix-clone-project",
  },
  {
    name: "Rock Paper Scissor game",
    description:
      "This is a fun and interactive Rock, Paper, Scissors game built for the web, featuring persistent memory through the use of the browser's local storage.With a simple and intuitive interface, this project showcases how client-side storage can be used to retain game history and enhance user experience without requiring any backend support.",
    tags: ["HTML", "CSS", "JS"],

    demo: "https://rock-paper-scissors-by-pratik.netlify.app/",
    github: "https://github.com/pratikk5/Rock-Paper-Scissor-game",
  },
  {
    name: "Real Time Clock",
    description:
      "This project features a Real-Time Clock built using JavaScript and styled with the Bootstrap framework to deliver a clean and responsive design. A sleek navigation bar is included at the top for structure and usability. The clock fetches and displays the current date and time in real-time, updating dynamically every second.",
    tags: ["HTML", "BootstrapCSS"],

    demo: "https://javascriptclockbypratik.netlify.app/",
    github: "https://github.com/pratikk5/clock-website-by-pratik",
  },
];
